import { render, staticRenderFns } from "./LogosEdit.vue?vue&type=template&id=38583347&scoped=true"
import script from "./LogosEdit.vue?vue&type=script&lang=js"
export * from "./LogosEdit.vue?vue&type=script&lang=js"
import style0 from "./LogosEdit.vue?vue&type=style&index=0&id=38583347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38583347",
  null
  
)

export default component.exports